import { useState } from "react";
import Layout from "@/components/Layout";
import PatientPicker from "@/components/PatientPicker";
import NotesPanel from "@/components/NotesPanel";
import { FileText } from "lucide-react";

export default function ClinicalNotes() {
  const [sel, setSel] = useState(null);
  return (
    <Layout title="Clinical Notes" subtitle="Hybrid — pull from Cliniko or write in-app. Notes feed the plan generator & Clinical Brain.">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="mb-2 text-xs font-semibold uppercase tracking-widest text-slate-400">Select patient</div>
          <PatientPicker value={sel} onChange={setSel} testid="notes-patient-picker" />
        </div>
        <div className="lg:col-span-8">
          {sel ? <NotesPanel clinikoId={sel} /> : (
            <div className="grid h-64 place-items-center rounded-2xl border border-dashed border-slate-300 text-slate-400">
              <div className="text-center"><FileText className="mx-auto mb-2 h-7 w-7" /> Select a patient to view & write notes</div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
